import angular, { IWindowService } from "angular";
import { IQuery } from "../../../records/server/query";
import {
  ServerUtility,
  vsName as ServerUtilityName,
} from "../../../records/server/serverUtility";
import { MachineConfigurationQuery } from "../models/machineConfiguration";

export const vsServiceName = "machineExportService";

export class MachineExportService {
  static $inject = ["$window", ServerUtilityName];
  constructor(
    private readonly $window: IWindowService,
    private readonly serverUtility: ServerUtility
  ) {}

  async slotfileDownload(query: MachineConfigurationQuery) {
    await this.getExport("sds", "slotfile.xlsx", query);
  }

  async assetMatrixDownload(query: MachineConfigurationQuery) {
    await this.getExport("olg", "assetMatrix.xlsx", query);
  }

  private getExport(type: string, fileName: string, query: IQuery) {
    const $window = this.$window;

    return this.serverUtility
      .sendApiRequest<any[]>({
        method: "POST",
        url: `/api/machines/Machine/export/${type}`,
        data: {
          query,
        },
        responseType: "blob",
      })
      .then((result) => {
        const blobUrl = $window.URL.createObjectURL(result);
        const downloadLink = angular.element("<a></a>");
        downloadLink.attr("href", blobUrl);
        downloadLink.attr("download", fileName);
        downloadLink[0].click();
      });
  }
}
